import { OBM_API_URL } from '@shared/constants/API.constants';
import Routes from '../../../domain/router/routes.constants';
import * as AuthService from '../../../domain/auth/auth-service';

const PERMISSION_REDIRECTS = {
    REDIRECT_TO_LOGIN: { path: Routes.AUTH_SIGN_IN, ignorePaths: [Routes.AUTH_SIGN_OUT] },
    REDIRECT_TO_LOGOUT: { path: Routes.AUTH_SIGN_OUT, ignorePaths: [Routes.AUTH_SIGN_IN] },
    USER_ON_WAITING_LIST: { path: Routes.WAITING_LIST },
    SKIP_INTEGRATION: { path: Routes.SKIP_INTEGRATION },
    USER_SIGN_UP_PENDING: { path: Routes.USER_SIGN_UP_PENDING },
};

const isUnauthorizedError = ({ status } = {}) => (
    status === 401
);

const pushHistoryByErrorType = (errorType, history) => {
    const { pathname, search, hash } = window.location;
    const { path, ignorePaths = [], query = {} } = PERMISSION_REDIRECTS[errorType];
    const ignoredPaths = [path, ...ignorePaths];
    if (!ignoredPaths.includes(pathname)) {
        const next = encodeURIComponent(`${pathname}${search}${hash}`);
        const queryString = Object.entries(({ ...query, next }))
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        history.push(`${path}?${queryString}`, { error: errorType });
    }
};

const shouldLogoutUser = (
    res, error,
) => isUnauthorizedError(res) && !isExternalService(error?.config?.url);

const getErrorTypeByResponse = (res = {}, error) => {
    if (shouldLogoutUser(res, error)) {
        return 'REDIRECT_TO_LOGOUT';
    }

    if (res.status === 403) return res.data && res.data.detail;
    return null;
};

const authServiceInterceptorBuilder = config => AuthService.getExchangedToken()
    .then(token => ({
        ...config,
        headers: {
            ...config.headers,
            Authorization: `Bearer ${token}`,
        },
    }));


export const setupLoginInterceptor = history => (client) => {
    client.interceptors.request.use(config => authServiceInterceptorBuilder(config)
        .catch((error) => {
            pushHistoryByErrorType('REDIRECT_TO_LOGIN', history);
            return Promise.reject(error);
        }));


    client.interceptors.response.use(
        response => response,
        (error) => {
            const errorType = getErrorTypeByResponse(error.response, error);
            if (errorType in PERMISSION_REDIRECTS) {
                pushHistoryByErrorType(errorType, history);
            }

            return Promise.reject(error);
        },
    );

    return client;
};

export const setupAuthTokenInterceptor = () => (client) => {
    client.interceptors.request.use(config => authServiceInterceptorBuilder(config)
        .catch(error => Promise.reject(error)));

    return client;
};

const EXTERNAL_SERVICES = [
    OBM_API_URL,
];

const isExternalService = url => EXTERNAL_SERVICES.find(el => url.includes(el));
